import { FormattedMessage } from 'react-intl'

import { Button } from '@gto/ui/button'
import { Typography } from '@gto/ui/typography'

export type EmailValidationSuccessProps = {
  onExploreDeals: () => void
}

export const EmailValidationSuccess = ({ onExploreDeals }: EmailValidationSuccessProps) => {
  return (
    <div className="flex max-w-[550px] flex-col gap-8">
      <Typography
        component="h1"
        variant="h4"
      >
        <FormattedMessage id="user.settings.email.validation.success.title" />
      </Typography>

      <Typography
        color="text.primary"
        variant="body1"
      >
        <FormattedMessage id="user.settings.email.validation.success.description" />
      </Typography>

      <Button
        className="min-w-[250px] self-start"
        color="primary"
        size="large"
        variant="contained"
        onClick={onExploreDeals}
      >
        <FormattedMessage id="user.settings.email.validation.success.exploreDeals" />
      </Button>
    </div>
  )
}
